import { httpRequest } from "@services/http";
import { PopulationSegment } from "@models/populationSegment.model";

export interface CreatePopulationSegmentPayload {
  name: string;
}

export class CommandCreatePopulationSegment {
  async run(organizationId: number, payload: CreatePopulationSegmentPayload): Promise<PopulationSegment> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/segments/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return PopulationSegment.fromJson(response);
  }
}
